import { useNavigate } from 'react-router'

import { updateRequestProfile } from '../../../../../api'
import { ROUTE_PATH_LIST } from '../../../../../constants/route'
import {
  useMinimizedModalsContext,
  useNotification,
} from '../../../../../hooks'
import { MINIMIZED_MODAL_REQUEST_PROFILE_SCOPES } from '../../../../Modal'
import { useRequestProfileContext } from '../../../RequestProfile.hooks'
import { REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY } from '../../RequestProfileActionsWidget.constants'

export function useRequestProfileMarkAsUnread({ requestId }) {
  const navigate = useNavigate()

  const {
    isPreview,
    outboundUuid,
    setPerformingAction,
    onSuccessMarkAsUnread,
  } = useRequestProfileContext()

  const { confirmBeforeAction } = useMinimizedModalsContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function navigateToList() {
    navigate(`/${ROUTE_PATH_LIST.serviceRequests}`, { replace: true })
  }

  async function handleMarkAsUnread() {
    setPerformingAction(true)

    return updateRequestProfile({
      data: { unread: true },
      id: requestId,
      outboundUuid,
    })
      .then(() => {
        handleAddSuccessNotification(
          REQUEST_PROFILE_ACTIONS_WIDGET_NOTIFICATION_TITLE_KEY.markAsUnread
        )

        if (isPreview) {
          onSuccessMarkAsUnread?.()

          return
        }

        navigateToList()
      })
      .catch(() => {
        setPerformingAction(false)

        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
  }

  function handleClickMarkAsUnread() {
    if (isPreview && confirmBeforeAction) {
      confirmBeforeAction(handleMarkAsUnread, {
        scope: MINIMIZED_MODAL_REQUEST_PROFILE_SCOPES,
      })

      return
    }

    handleMarkAsUnread()
  }

  return { handleClickMarkAsUnread }
}
